import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { IonCol, IonGrid, IonIcon, IonRow } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { EStopType, IFreightBasicForCarrier } from '@okcargo-apps/shared-domain';
import { FreightCarrierInprogressCardAddressComponent } from '../freight-carrier-inprogress-card-address/freight-carrier-inprogress-card-address.component';
import { FreightCarrierInprogressCardScheduleComponent } from '../freight-carrier-inprogress-card-schedule/freight-carrier-inprogress-card-schedule.component';

@Component({
  selector: 'lib-freight-carrier-inprogress-card-basic',
  templateUrl: './freight-carrier-inprogress-card-basic.component.html',
  styleUrls: ['./freight-carrier-inprogress-card-basic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    IonIcon,
    IonCol,
    IonRow,
    IonGrid,
    FreightCarrierInprogressCardAddressComponent,
    FreightCarrierInprogressCardScheduleComponent,
    TranslateModule,
  ],
})
export class FreightCarrierInprogressCardBasicComponent {
  readonly hideColumns = input(false);

  readonly freight = input.required<IFreightBasicForCarrier>();

  readonly EStopType = EStopType;

  protected isStopActive(stopId: string): boolean {
    return stopId === this.freight().nextStopId;
  }
}
